"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequestForQuoteHeaderSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class RequestForQuoteHeaderSearchResponse extends common_1.PaginatedResponse {
}
exports.RequestForQuoteHeaderSearchResponse = RequestForQuoteHeaderSearchResponse;
//# sourceMappingURL=request-for-quote-header-search.response.js.map